import React from "react";
import { Row, Col } from "reactstrap";
// Used by Heli KV2008B and Heli KV2019B machines

export default function ParameterSection({ titleProp }) {
   return (
      <Row className="pt-3">
         <Col xxl={6} lg={5}>
            <u>
               <h5 className="text-end fw-bold">
                  {titleProp}
               </h5>
            </u>
         </Col>
      </Row>
   );
}